import type { UserFeature } from '../types'

export const isFeatureEnabled = (userFeatures: UserFeature[], featureName: string): boolean =>
  !!userFeatures.find((f) => f.feature_name === featureName)?.is_enabled
